__turbopack_context__.v({
  "active": "CorePageJumpLinkNavigation-module-scss-module__Wuc-IG__active",
  "button": "CorePageJumpLinkNavigation-module-scss-module__Wuc-IG__button",
  "desktop": "CorePageJumpLinkNavigation-module-scss-module__Wuc-IG__desktop",
  "dropdown": "CorePageJumpLinkNavigation-module-scss-module__Wuc-IG__dropdown",
  "dropdown-icon": "CorePageJumpLinkNavigation-module-scss-module__Wuc-IG__dropdown-icon",
  "dropdown-label": "CorePageJumpLinkNavigation-module-scss-module__Wuc-IG__dropdown-label",
  "header": "CorePageJumpLinkNavigation-module-scss-module__Wuc-IG__header",
  "list": "CorePageJumpLinkNavigation-module-scss-module__Wuc-IG__list",
  "main": "CorePageJumpLinkNavigation-module-scss-module__Wuc-IG__main",
  "select": "CorePageJumpLinkNavigation-module-scss-module__Wuc-IG__select",
});
